import { AutoComplete } from "primereact/autocomplete";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MultiSelect } from 'primereact/multiselect';

const SiteAutoCompleteInput = (props) => {
    const [suggestions, setSuggestions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const { assignedTo } = props;

    // Get site options from Redux store
    const storeOtions = useSelector((state) => state.common.storeList);

    useEffect(() => {
        if (assignedTo) {
            setSelectedItems(assignedTo.split(',').map(num => parseInt(num, 10)));
        }
    }, [assignedTo]);

    const fetchSuggestions = (event) => {
        const query = event.query.toLowerCase(); // Case insensitive search
        const filteredSuggestions = storeOtions.filter(option => 
            option.label.toLowerCase().includes(query) // Adjust the field to match your data structure
        );
        setSuggestions(filteredSuggestions);
    };

    const onStoreSelect = (e) => {
        setSelectedItems(e.value);
        props.handleSearchSite(e.value);
    };

    const handleSiteMultiSelect = (value) => {
        const selectedValue = value;
        setSelectedItems(value);
        props.handleSiteAssignedTo(selectedValue?.join(',') || '');
        //formik.setFieldValue('assignedTo', selectedValue?.join(',') || '');
    };

    return (
        <div className="w-full">
            {/* <AutoComplete
                forceSelection
                value={selectedItems}
                suggestions={suggestions}
                completeMethod={fetchSuggestions}
                field="label" // Ensure this matches the key in your siteOptions
                placeholder="Search for site"
                onSelect={onStoreSelect}
            /> */}
             <MultiSelect 
                id="siteAssignedTo"
                value={selectedItems} 
                onChange={(e) => handleSiteMultiSelect(e.value)} 
                options={storeOtions}
                optionLabel="label" 
                filter 
                placeholder="Select Site" 
                className="w-full"
                maxSelectedLabels={3} />
        </div>
    );
};

export default SiteAutoCompleteInput;
